import _slicedToArray from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _taggedTemplateLiteral from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  margin-top: ", ";\n  min-height: ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  align-items: center;\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { __rest } from "tslib";
import React, { Fragment, useState, useEffect } from 'react';
import styled from 'styled-components';
import { CopyButton } from '@scp/ui-shared/components/buttons/CopyButton';
import { IconButton } from '@scp/ui-shared/components/buttons/IconButton';
import { Heading1, Paragraph } from '@scp/ui-shared/components/typography';
import { Icon } from '@scp/ui-shared/theme/icons';
import { TextField } from '@scp/ui-shared/components/form-fields';
import { baselineToRem } from '@scp/ui-shared/theme/utils';
import { Modal } from './Modal';
var TEXT = {
  TITLE: 'Share',
  DEFAULT_LABEL: 'Link',
  CLOSE_TITLE: 'Close',
  COPY_LABEL: 'Copy',
  COPY_SUCCEEDED: 'Link copied to clipboard'
};
var HeaderRow = styled.div(_templateObject(), baselineToRem(3));
var CopyConfirmationParagraph = styled(Paragraph)(_templateObject2(), baselineToRem(1), baselineToRem(6));
export function ShareModal(_a) {
  var link = _a.link,
      onClose = _a.onClose,
      open = _a.open,
      additionalContent = _a.additionalContent,
      _a$title = _a.title,
      title = _a$title === void 0 ? TEXT.TITLE : _a$title,
      rest = __rest(_a, ["link", "onClose", "open", "additionalContent", "title"]);

  var links = Array.isArray(link) ? link : [link];

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      copiedIndex = _useState2[0],
      setCopiedIndex = _useState2[1];

  useEffect(function () {
    setCopiedIndex(null);
  }, [open]);

  var handleCopy = function handleCopy(index) {
    setCopiedIndex(index);
  };

  return React.createElement(Modal, Object.assign({
    onRequestClose: onClose,
    noPadding: true,
    open: open
  }, rest), React.createElement(HeaderRow, null, React.createElement(Heading1, {
    noMargin: true
  }, title), React.createElement(IconButton, {
    onClick: onClose,
    title: TEXT.CLOSE_TITLE,
    concise: true
  }, React.createElement(Icon, {
    name: "close"
  }))), links.map(function (linkItem, index) {
    return React.createElement(Fragment, {
      key: linkItem.value
    }, React.createElement(TextField, {
      id: linkItem.value,
      label: linkItem.label || TEXT.DEFAULT_LABEL,
      value: linkItem.value,
      readOnly: true,
      hideError: true,
      infieldActions: React.createElement(CopyButton, {
        textToCopy: linkItem.value,
        onCopyToClipboard: function onCopyToClipboard() {
          return handleCopy(index);
        },
        includePopover: false
      })
    }), React.createElement(CopyConfirmationParagraph, {
      secondary: true,
      noMargin: true
    }, index === copiedIndex && TEXT.COPY_SUCCEEDED));
  }), additionalContent);
}